import React, { useEffect, useState } from 'react'
import ScreenNavigator from './components/ScreenNavigator'
import SelectTeam from './components/SelectTeam'
import { Link, useLocation } from 'react-router-dom'
import TeamSetting from './components/TeamSetting'
import { v4 } from 'uuid'
import placeHolderImg from '../../../../../../../assets/Bulk Upload.png'

const CreateTeam = () => {

 const [isCreated, setIsCreated] = useState(false)
 const [status, setStatus] = useState(true)
 const [ activeScreen, setActiveScreen] = useState(1)
 const [selectedCohort, setSelectedCohort] = useState(null)
 const [selectedTeams, setSelectedTeams] = useState([])
 const [teams, setTeams] = useState([ { id: v4(), name: '' } ])

 const location = useLocation();

  useEffect(() => {
    document.querySelectorAll('*').forEach( element => {
       element.scroll({top: 0, left: 0, behavior: 'instant'})
    })
  }, [activeScreen]);                     

  return (
    <section className='p-3'>
      <h5 className='text-md flex justify-between'>
            Team Management
            <Link to={-1} className='text-white bg-customBlue text-sm px-8 py-2 rounded-full bi bi-arrow-left'>
                &nbsp;Back
            </Link>
        </h5>
    <section className="border flex justify-between pr-0 px-7 border-slate-400 rounded-lg mx-3 mt-8">
    <div className="w-[40%] py-7 flex justify-center items-center">
       <img className='w-[300px] h-[240px]' src={placeHolderImg} alt="placeholder image" />
    </div>
    <div className="rounded-e-lg w-[58%] p-3 bg-white">
    <div>
        <header>
            <ScreenNavigator
                activeScreen={activeScreen}
                set1Validated={isCreated}
                setIsCreated={setIsCreated}
                setActiveScreen={setActiveScreen}
                title1={'Select Team'}
                title2={'Team Setting'}
            />
        </header>
         { activeScreen === 1 ? 
           <SelectTeam 
             status={status} setStatus={setStatus}
             setIsCreated={setIsCreated}
             setSelectedCohort={setSelectedCohort}
             selectedCohort={selectedCohort}
             setActiveScreen={setActiveScreen}
             teams={teams}
             setTeams={setTeams}
             selectedTeams={selectedTeams}
             setSelectedTeams={setSelectedTeams}
           /> 
        : null }
         { 
            activeScreen === 2 ? 
              <TeamSetting selectedTeams={selectedTeams} selectedCohort={selectedCohort} /> 
            : null 
         }
    </div>
    </div>
  </section>
  </section>
  )
}

export default CreateTeam